import styled from 'styled-components/macro'

import { Field, Toggle } from '@loadsmart/miranda-react'
import { getToken, toCSSValue } from '@loadsmart/miranda-react/dist/tokens'

import { screen } from 'legacy/styles/screen'

export const GridWrapper = styled.div`
  display: grid;
  gap: ${getToken('spacing-4')};

  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: auto;
  grid-template-areas:
    'lane lane'
    'radius preferred-lane'
    'date date'
    'mode equipment'
    'type feature';

  ${screen.md} {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-template-rows: auto;
    grid-template-areas:
      'lane lane lane radius'
      'preferred-lane date date date'
      'mode equipment type feature';
  }

  ${screen.lg} {
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: auto;
    grid-template-areas:
      'lane lane radius preferred-lane date'
      '. mode equipment type feature';
  }

  ${screen.xlg} {
    grid-template-columns: repeat(7, 1fr);
    grid-template-rows: auto;
    grid-template-areas:
      'lane lane lane radius preferred-lane date date'
      '. . . mode equipment type feature';
  }
`

export const StyledToggle = styled(Toggle)`
  border: 1px solid ${toCSSValue('color-border')};
  border-radius: ${getToken('border-radius-s')};
  background-color: ${toCSSValue('color-background-primary')};
  padding: ${getToken('spacing-1')};
  height: 40px;
  width: 100%;
`

export const PreferredLanesWrapper = styled.div`
  display: flex;
  align-items: flex-end;
`

export const StyledField = styled(Field)`
  ${screen.md} {
    max-width: 220px;
  }
`
